var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkAuthorization.passAccount)?_c('div',[_c('v-row',[_c('v-col',[_c('Tabs',{attrs:{"tabs":_vm.tabs}})],1)],1),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }